import Vue from './main.js';
import {router} from './main.js';

export default {

    permissions: {
        IS_ADMIN: 'is_admin',
        IS_LEADER: 'is_leader',
        //IS_USER: 'is_user'//every logged in therapist is_user, so this is obsolete
    },

    user: {
        authenticated: false,
        profile: {
            permissions: null,
            email: null,
            firstName: null,
            lastName: null,
            serviceName: null,
            serviceId: null,
            id: null
        }
    },

    tokenRefreshTimeout: null,
    useRefreshTimeout: false, //do not use refresh timeout

    verifyToken(onSuccess) {
        let token = localStorage.getItem('id_token')
        if (token !== null) {
            Vue.http.get(
                'api/v1/auth/check',
            ).then(response => {
                this.storeUserData(response);
                onSuccess();
            }, response => {
                //if there is an error -> signout
                this.signout(this);
            })
        }
    },

    refresh() {
        Vue.http.post(
            'api/v1/auth/refresh'
        ).then(response => {

            this.setToken(response);
            this.storeUserData(response);

        }, response => {
            this.signout();
        })
    },

    signin(context, email, password) {
        Vue.http.post(
            'api/v1/login',
            {
                email: email,
                password: password
            }
        ).then(response => {
            context.error = false;
            context.isLoading = false;

            this.setToken(response);
            this.storeUserData(response);

            router.push({
                name: 'home'
            })
        }, response => {
            context.error = true;
            context.isLoading = false;
        })
    },

    register(context, username, email, password) {
        Vue.http.post(
            'api/v1/register',
            {
                email: email,
                username: username,
                password: password
            }
        ).then(response => {

            context.error = false;
            context.isLoading = false;

            router.push({
                name: 'signin'
            })
        }, response => {
            context.error = true;
            context.isLoading = false;
        })
    },

    signout() {

        Vue.http.post(
            'api/v1/auth/logout'
        ).then(response => {
            this.clearToken();
        }, error => {
            this.clearToken();
        })
    },

    clearToken() {
        localStorage.removeItem('id_token');
        Vue.http.headers.common['Authorization'] = 'Bearer null';//set auth header explicitly to Bearer with empty/null token

        this.user.authenticated = false;
        this.user.profile.permissions = null;
        this.user.profile.email = null;
        this.user.profile.firstName = null;
        this.user.profile.lastName = null;
        this.user.profile.serviceName = null;
        this.user.profile.serviceId = null;
        this.user.profile.id = null;

        //only push to signin if we are not already there (because vue does not like it)
        if(router.currentRoute.name !== 'signin') {
            router.push({
                name: 'signin'
            })
        }
    },

    storeUserData(response) {
        this.user.profile.permissions = response.body.therapist_data.permissions;
        this.user.profile.email = response.body.therapist_data.email;
        this.user.profile.firstName = response.body.therapist_data.first_name;
        this.user.profile.lastName = response.body.therapist_data.last_name;
        this.user.profile.serviceName = response.body.therapist_data.service_name;
        this.user.profile.serviceId = response.body.therapist_data.service_id;
        this.user.profile.id = response.body.therapist_data.id;
        this.user.authenticated = true;
    },

    setToken(response) {

        localStorage.setItem('id_token', response.body.access_token);
        Vue.http.headers.common['Authorization'] = 'Bearer ' + response.body.access_token;

        if(this.useRefreshTimeout) {
            this.setTokenRefreshTimeout(response.body.ttl * 1000);//ttl*1000=milliseconds
        }
    },

    setTokenRefreshTimeout(milliseconds) {

        if(this.tokenRefreshTimeout !== null) {
            clearTimeout(this.tokenRefreshTimeout);
        }
        this.tokenRefreshTimeout = setTimeout(() => {
            //if timer still existent: refresh!
            this.refresh();
        }, (milliseconds - 5*60*1000));//timer expires in ttl minus 5 minutes, so early enough to still be valid
    },

    isUserAuthenticated() {
        return this.user.authenticated;
    }
}